import { Choice } from './Choice';

export class BasketProduct {
    id: number;
    productId: number;
    name: string;
    quantity: number;
    basecost: number;
    totalcost: number;
    source: string;
    specialinstructions: string;
    recipient: string;
    choices: Array<Choice>;
    customdata?: string;
    chainproductid?: string;

    constructor(init?: Partial<BasketProduct>) {
        Object.assign(this, init);
    }

    public static Make(obj: any): BasketProduct {
        const basketProduct = new BasketProduct();
        Object.assign(basketProduct, obj);
        return basketProduct;
    }
}
